import { gql } from '@apollo/client';

export const TEXT_TO_SPEECH = gql`
  mutation TextToSpeech($input: TextToSpeechInput!) {
    textToSpeech(input: $input) {
      url
      speechMarks {
        type
        time
        start
        end
        value
      }
    }
  }
`;
